'use strict'
/**
 * DisplayErrorMixin
 */

// APIが返却したエラーを表示する
function errorFromApi (code, msg) {
  console.error('[FKMO Error]', code, msg)
  window.commonAlert(msg)
}

// axiosで発生したエラーを表示する
function errorFromAxios (error) {
  console.error('[FKMO Error]', error)

  if (error.response) {
    // サーバーからエラー応答があった場合
    if (error.code === 'ECONNABORTED') {
      // タイムアウト
      window.commonAlert(this.$i18n.t('ErrorMsg.ERR_901'))
    } else if (error.response !== null && error.response !== undefined && error.response.status >= 400) {
      // エラーレスポンスあり
      window.commonAlert(this.$i18n.t('ErrorMsg.ERR_902'))
    } else {
      window.commonAlert(this.$i18n.t('ErrorMsg.ERR_999'))
    }
  } else if (error.request) {
    // リクエストがキャンセルされた場合
    if (error.request.status === 0) {
      // リクエストがタイムアウトしている場合はalertでのエラー表示をしない。
      console.error('[FKMO Error] Timeout. Request was canceled.')
    } else {
      window.commonAlert(this.$i18n.t('ErrorMsg.ERR_999'))
    }
  } else {
    window.commonAlert(this.$i18n.t('ErrorMsg.ERR_999'))
  }
}

// アプリケーションエラー
function errorFromApp (type, error) {
  switch (type) {
    case 'ErrorMsg.ERR_101':
      console.error('[FKMO Error]', error)
      window.commonAlert(this.$i18n.t(type))
      break
    default:
      console.error('[FKMO Error]', error)
      window.commonAlert(this.$i18n.t('ErrorMsg.ERR_999'))
      break
  }
}

export default {
  data () {
    return {
    }
  },
  methods: {
    errorFromApi,
    errorFromAxios,
    errorFromApp
  }
}



// WEBPACK FOOTER //
// ./src/mixins/DisplayErrorMixin.js